import { useContext } from 'react';
import { CustomTableData } from "common";
import { Button } from '@mui/material'
import { Edit3, Info, Trash2 } from 'react-feather'
import { TooltipInformation } from 'common';
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'

export const ExpensesTable = ({useFetchInit}) => {

  const {
    FetchData,
    Actions,
    globalStates
  }= useFetchInit


  const {fetchAllLegalExpenses:{legalExpenses}} = FetchData

  const {handleButtonDeleteExpenses} = Actions

  
  const columnConfig = [
    {
      headerName: 'info',
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {

        const {
          idcredito,
          usuario_creo,
          fecha_creo,
          usuario_modifico,
          fecha_modifico,
        } = params.data;
        
        return <TooltipInformation
          idregistro={idcredito}
          usuario_creo={usuario_creo}
          fecha_creo={fecha_creo}
          usuario_modifico={usuario_modifico}
          fecha_modifico={fecha_modifico}
        />
      },
    },
    { 
      field: "gasto_fecha",
      headerName: "FECHA",
      minWidth: 130,
      maxWidth: 130,
      filter: true,
      cellStyle: (params) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "left"
      }),
    } ,
    { field: "gasto_descripcion", headerName: "DESCRIPCION DEL GASTO", minWidth: 700, filter: true },
    { field: "gasto_monto", headerName: "MONTO", minWidth: 130, filter: true },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

        const {idgasto} = params.data

        return <>
          {/* <Button 
              startIcon = { <Info/>}
              variant='contained'
              size='small' 
              color='info'
              sx={{ marginRight: '8px' }}
              // onClick={() => handleClickFetchInfoExpenses()} 
              style={ { width: 150 } }
              > 
              Informacion
          </Button> */}
          <Button 
            startIcon = { <Trash2/>}
            variant='contained'
            size='small' 
            color='error'
            sx={{ marginRight: '8px' }}
            onClick={()=>handleButtonDeleteExpenses(idgasto)} 
            style={ { width: 150 } }
            > 
            Elimar
          </Button>
        </>

      },
    },
  ];
  return (
    <>
      <CustomTableData
        rowConfig={legalExpenses}
        columnConfig={columnConfig} />
    </>
  );
};
